import React from 'react';
import PropTypes from 'prop-types';

const ToastMessage = ({ body, title, icon }) => {
  return (
    <div className="toast-message">
      {icon ? <img src={icon} alt="notification" className="toast-message__icon" /> : null}
      <div className="toast-message__info">
        {title ? <p className="toast-message__info__title">{title}</p> : null}
        {body ? <p className="toast-message__info__message">{body}</p> : null}
      </div>
    </div>
  );
};

ToastMessage.propTypes = {
  body: PropTypes.string,
  title: PropTypes.string,
  icon: PropTypes.string
};

export default ToastMessage;
